import "core-js/modules/es.array.map.js";
import React from 'react';
import { FileText } from '@finect/tabular-icons/fileText';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Small } from '@finect/tabular-core/Small';
import { TableList } from '../../Tables';
import { DateLabel } from '../../DateLabel';
export var FundDocuments = function FundDocuments(_ref) {
  var fund = _ref.fund;
  var documents = fund.documents;
  var rows = documents.map(function (document) {
    return {
      cells: [{
        params: {
          type: 'CellWithIcon'
        },
        component: React.createElement("span", null, React.createElement("span", null, React.createElement(FileText, {
          size: "24px"
        })), React.createElement("div", null, document.type, React.createElement("br", null), React.createElement(Small, {
          light: true
        }, React.createElement(DateLabel, {
          noTimeTag: true,
          date: new Date(document.effective || document.updated)
        }))))
      }, {
        params: {},
        component: React.createElement(AppLink, {
          href: document.url,
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          "data-fi-event": "product-document"
        }, "Descargar")
      }]
    };
  });
  return React.createElement(TableList, {
    rows: rows
  });
};